import data from '../images/data2.svg';
import construct from '../images/construction.svg';

export const construction = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Construimos huertos tecnologicos',
  headline: 'Ofrecemos un avance tecnologico para huertos urbanos',
  description:
    'Ofrecemos huertos urbanos optimizados, usamos inteligencia artificial para saber cuando regar o cuanto luz necesita tu cultivo.',
  buttonLabel: 'Leer más',
  linkTo: 'signup',
  imgStart: 'start',
  img: construct,
  alt: 'Data'
};

export const cienciaDeDatos = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Ciencia De Datos',
  headline: 'Ofrecemos estadísticas de tus cosechas para mejorarlas',
  description:
    'Analizamos los datos para ofrecer un mejor servicio y los abrimos anónimamente a la comunidad, para así enfocarnos en una mejor experiencia de usuario, cosechas más fértiles y ahorro de tiempo.',
  buttonLabel: 'Registrate Ahora',
  linkTo: 'signup',
  imgStart: '',
  img: data,
  alt: 'Data'
};